module.exports = __webpack_public_path__ + "static/HDBR-Cotidiano-4-c74fc2ff53627008b3ce1240ae37f224.jpg";